import axios, { dataApi, surveysAPI } from 'config/axios';

const setIntercomToken = (intercomToken) => {
    //Apply on every request
    if (intercomToken) window.localStorage.setItem('intercomToken', intercomToken);
};

export default setIntercomToken;
